import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { update_page_meta } from "../../actions/page/header";
import { listStores } from "../../actions/store/store";
import PageHeader from "../../components/page/PageHeader";
import { useNavigate } from "react-router-dom";
import { HomePageURL } from "../../assets/const";
import OrganizationScroller from "../../components/OrganizationScroller";
import { useSelectedOrganizations } from "../../reducers/accounts/user";
import { getUserList } from "../../actions/accounts/user";

const TeamList = ({ update_page_meta }) => {
  update_page_meta({
    title: "Team",
    description: "Sales Team",
  });
  const selectedOrganizations = useSelectedOrganizations();
  const reload = useRef(false);
  const [Page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(18);
  const [numPages, setNumPages] = useState(0);
  const [count, setCount] = useState(0);
  const [Team, setTeam] = useState([]);
  const list_team = async () => {
    let res = await getUserList(
      Page,
      perPage,
      selectedOrganizations?.map((item) => item.id),
      ["Salesman"]
    );
    if (res?.success) {
      if (reload.current) setTeam([...res?.users]);
      else setTeam([...Team, ...res?.users]);
      setNumPages(res?.num_pages);
      setCount(res?.count);
    }
    reload.current = false;
  };
  useEffect(() => {
    list_team();
  }, [Page]);
  useEffect(() => {
    reload.current = true;
    if (Page !== 1) setPage(1);
    else list_team();
  }, [selectedOrganizations]);
  let navigate = useNavigate();
  const rows = Team?.map((user, index) => {
    return (
      <tr key={index}>
        <td>
          <img style={{ height: "50px" }} src={user?.profile_pic_url} alt="" />
        </td>
        <td>{user?.full_name}</td>
        <td>{user?.designation}</td>
        <td
          className="cursor-pointer"
          onClick={() =>
            navigate(`${HomePageURL}/team/${user?.id}/`, { replace: false })
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="feather feather-arrow-right"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </td>
      </tr>
    );
  });
  return (
    <>
      <PageHeader title="Team" />
      <div className="row layout-top-spacing" id="cancel-row">
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <OrganizationScroller />
            <div className="table-responsive mb-4 mt-4">
              <table
                id="zero-config"
                className="table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="no-content"></th>
                    <th>Name</th>
                    <th>Designation</th>
                    {/* <th>Suborganization</th>
                                        <th>Created By</th>
                                        <th>Approval Status</th> */}
                    <th className="no-content"></th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
                <tfoot>
                  <td colSpan={6} className="p-3">
                    {Page < numPages ? (
                      <span role="button" onClick={() => setPage(Page + 1)}>
                        Load More
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-arrow-right"
                        >
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                          <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                      </span>
                    ) : (
                      <p>You are all caught up</p>
                    )}
                  </td>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta })(TeamList);
